/**
 * Image With Repeat Data: swap the image when an item is hovered/focused.
 * Scoped to .image-with-repeat-data so other sections are unaffected.
 */
$(function () {
  $('.image-with-repeat-data').each(function () {
    const $section = $(this);
    const $items = $section.find('.image-with-repeat-data__item');
    const $images = $section.find('.image-with-repeat-data__image-item');
    if (!$images.length) return;

    const activate = function (index) {
      if (!$images.filter(`[data-index="${index}"]`).length) return;
      $items
        .removeClass('is-active')
        .filter(`[data-index="${index}"]`)
        .addClass('is-active');
      $images
        .removeClass('is-active')
        .filter(`[data-index="${index}"]`)
        .addClass('is-active');
    };

    $items.attr('tabindex', 0);
    $items.on('mouseenter focus click', function () {
      activate($(this).data('index'));
    });
  });
});
